import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Uris } from '../public/Uris';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { GlobalFunction } from '../public/globalFunction';

@Injectable({
  providedIn: 'root',
})
export class ReportsGlobalService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public GlobalFunction: GlobalFunction
  ) {}

  getReport(query: any) {
    return this.http
      .get(`${Uris.REPORTS}${query}`, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getIndividualReport(sector, pathing, report) {
    return this.http
      .get(
        `${Uris.API_CYCLES}${sector}/pathings/${pathing}/reports/${report}/`,
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  postIndividualReport(obj) {
    return this.http
      .post(`${Uris.REPORTS}individual/`, obj, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  editIndividualReport(obj, id) {
    return this.http
      .patch(`${Uris.REPORTS}${id}/`, obj, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  imageUpload(id, img) {
    return this.http
      .post(
        `${Uris.REPORTS}${id}/image_upload/`,
        img,
        this.GlobalFunction.headersMultipart()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteIndividualReportImage(reportID, imageIndexToDelete: number) {
    return this.http
      .post(
        `${Uris.REPORTS}${reportID}/delete_image/`,
        { image_index: imageIndexToDelete },
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  videoUpload(id, img) {
    return this.http
      .post(
        `${Uris.REPORTS}${id}/video_upload/`,
        img,
        this.GlobalFunction.headersMultipart()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteIndividualReportVideo(reportID) {
    return this.http
      .post(
        `${Uris.REPORTS}${reportID}/delete_first_video/`,
        {},
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  audioUpload(id, img) {
    return this.http
      .post(
        `${Uris.REPORTS}${id}/audio_upload/`,
        img,
        this.GlobalFunction.headersMultipart()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteIndividualReportAudio(reportID) {
    return this.http
      .post(
        `${Uris.REPORTS}${reportID}/delete_first_audio/`,
        {},
        this.GlobalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }
}
